import * as yup from 'yup';

const descriptionMaxLength: number = 1000;

export const VerificationStatusTrackerScheme = yup.object({
    scheduledDate: yup.date().required().typeError('Scheduled date is required'),
    statusDate: yup.date().required().typeError('Status date is required'),
    verificationStatus: yup.number().required().typeError('Status is required'),
    verificationProcessTypeId: yup.number().required().typeError('Process type is required'),
    note: yup.string().max(descriptionMaxLength, "Note is too long").nullable(),
},
)